import Portal from './PortalCompat';
import PortalWithState from './PortalWithState';

export { Portal, PortalWithState };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-portal/es/index.js
// module id = 166
// module chunks = 0